module.exports = __webpack_public_path__ + "static/media/payment-icon-discover.423a3045.svg";